export default "__VITE_ASSET__CVhmiLVp__"